import React from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { addNewPaymentLine } from 'client/utils/api-routes-invoice'
import _ from 'lodash'
import {
  DcButton,
  DcDropDown,
  DcInput,
  DcOverlaySlider,
  PixelFactoryContext,
  PixelIcon,
} from 'pixel-base'
import styled from 'styled-components'

import AddNewPaymentMethod from './common/AddNewPaymentMethod'
import {
  Customer,
  IPixelFactory,
  OrderDetail,
  PaymentMethod,
} from '../../../../../../decl.d'

const PaymentMethodTypes = (item) => {
  switch (item.method_type) {
    case 'card':
      return item.card_number
    case 'venmo':
    case 'zelle':
    case 'Prepaids':
    case 'cashapp':
    case 'paypal':
      return item.account_id
    case 'bank':
      return item.account_number
  }
}
interface IProps {
  paymentMethods: PaymentMethod[]
  customerData: Customer
  newPaymentMethod: PaymentMethod
  setCustomerData: (customerData: Customer) => void
  detailID: number
  handleClose: () => void
  details: OrderDetail
}
const InvoicePaymentsAdd = (props: IProps) => {
  const {
    showSuccess,
    showFailure,
    showPageLoader,
    hidePageLoader,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const [addNewPaymentMethod, setaddNewPaymentMethod] = React.useState(false)
  const {
    paymentMethods,
    customerData,
    newPaymentMethod,
    setCustomerData,
    detailID,
    handleClose,
    details,
  } = props

  const formatOptions = (data) => {
    const options = _.groupBy(data, 'method_type')
    Object.keys(options).map((key) => {
      return options[key].map((item) => {
        item.value = item.payment_method_id
        item.label = PaymentMethodTypes(item)

        return item
      })
    })
    return options
  }
  const [data, setData] = React.useState<any>({
    amount: '',
    currency: '',
    gateway_id: '26',
    payment_method_id: 0,
  })
  const tenant_info: any = JSON.parse(
    localStorage.getItem('tenant_info') || '{}',
  )
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const getConfirmMessage = (data: any) => {
    let message = ''
    data.amount = parseFloat(data.amount)
    details.total = parseFloat(details.total)
    if (data.amount < details?.total) {
      message =
        'As the received amount is less than total invoice amount, the invoice will be marked as "Partially Paid"'
    }

    if (data.amount === details?.total) {
      message = 'The invoice will be marked as "Paid"'
    }
    if (data.amount > details?.total) {
      message =
        'As the amount received is more than the invoice total, extra amount will be added towards the customer balance'
    }

    return message
  }

  const HandleAddNewPayments = (detailID) => {
    pixelConfirm({
      title: 'Delete Transaction',
      message: getConfirmMessage(data),
      onConfirm: () => {
        showPageLoader()
        data.currency = tenant_info.default_currency
        addNewPaymentLine(detailID, data).subscribe((res: any) => {
          hidePageLoader()
          if (res.response.data) {
            showSuccess('Payment added successfully')

            handleClose(res.response?.data)
          } else {
            if (res.response.field) {
              setError({
                error: res.response.error,
                field: res.response.field,
              })
            } else {
              showFailure(res.response.error)
            }
          }
        })
      },
    })
  }
  React.useEffect(() => {
    const tenantData = JSON.parse(localStorage.getItem('tenant_info') || '{}')
    setData({
      ...data,
      currency: tenantData?.default_currency,
    })
  }, [])

  return (
    <Container>
      <FormGroup>
        <DcInput
          error={
            error.field === 'amount' && error.error !== '' ? error.error : null
          }
          required
          type={'number'}
          name={'amount'}
          placeholder={'Enter received amount'}
          value={data.amount}
          onChange={(e) => {
            setData({ ...data, amount: e.target.value })
          }}
        />
        <DcDropDown
          error={
            error.field === 'gateway_id' && error.error !== ''
              ? error.error
              : null
          }
          required
          options={[
            {
              title: 'Payment Gateway',
              id: '',
            },
            ...paymentMethods,
          ]?.map((data) => {
            return {
              label: data.title,
              value: data.id,
            }
          })}
          value={data.gateway_id}
          onChange={(e) => {
            setData({ ...data, gateway_id: e.target.value })
          }}
          placeholder={'Payment Gateway'}
        />
      </FormGroup>
      <FormGroup>
        <ButtonsContainer>
          <DcDropDown
            isgrouped={true}
            placeholder={'Select Payment Method'}
            error={
              error.field === 'payment_method_id' && error.error !== ''
                ? error.error
                : null
            }
            required
            groupOptionData={formatOptions(customerData?.payment_methods)}
            value={data.payment_method_id}
            onChange={(e) => {
              setData({ ...data, payment_method_id: e.target.value })
            }}
          />

          <PixelIcon
            showTooltip
            tooltip="Add new"
            onClick={() => {
              setaddNewPaymentMethod(true)
            }}
            fontSize="20px"
            icon={faPlus}
          />
        </ButtonsContainer>
        <ButtonsContainer>
          <DcButton
            onClick={() => {
              handleClose()
            }}
            size="sm"
            variant="outline-secondary"
          >
            Close
          </DcButton>
          <DcButton
            disabled={data.amount === '' || data.payment_method_id === 0}
            onClick={() => {
              HandleAddNewPayments(detailID)
            }}
            size="sm"
            variant="primary"
          >
            Submit
          </DcButton>
        </ButtonsContainer>
      </FormGroup>
      {addNewPaymentMethod && (
        <DcOverlaySlider
          isOpen={addNewPaymentMethod}
          onClose={() => setaddNewPaymentMethod(false)}
          title={'Add New Payment Method'}
          width="50%"
        >
          {addNewPaymentMethod && (
            <AddNewPaymentMethod
              newPaymentMethod={newPaymentMethod}
              customerData={customerData}
              handleClose={(paymentData) => {
                if (paymentData) {
                  setCustomerData(paymentData)
                  setData({
                    ...data,
                    payment_method_id:
                      paymentData?.payment_methods[0]?.payment_method_id,
                  })
                }
                setaddNewPaymentMethod(false)
              }}
            />
          )}
        </DcOverlaySlider>
      )}
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
`
const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-end;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const ButtonsContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: flex-end;
  gap: 10px;
`
export default InvoicePaymentsAdd
